import React, { Component } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import { StyleSheet, View } from 'react-native';
import Button from '@dbk/ui-buttons';
import Text, { Large } from '@dbk/ui-text';
import { Contract } from '@dbk/ui-icons';
import Modal from '@dbk/ui-modal'
import { PALETTE, DOCSIGN_CONSTANTS } from '../../../constants';
import { LoadingCircle } from '../../../components/common/loading';
import styles from './docusign-response-modal.styles';
import BlurModal from '../../../components/common/blur-modal';
import { SuccessTickIcon } from '../../../components/common/icons';
import Loading from '../../../components/common/loading/loading-circle';

let userAction = "";

class DocusignResponseModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      docusignResponseReceived: false
    }
    this.onOKButton = this.onOKButton.bind(this);
  }

  componentWillMount() {
    const {
      i18n: { messages },
      docusignaccept: { docuSignURLResponse },
    } = this.props;
    const action = this.props.docusignaccept.signAction;

    this.props.completeDocumentSign(docuSignURLResponse.data.txId, action, this.props.docusignaccept.documentName);

    if (action === DOCSIGN_CONSTANTS.DOCUSIGN_SIGNING_COMPLETE) {
      userAction = messages['app.docusign.digisign.usersigned'];
    } else if (action === DOCSIGN_CONSTANTS.DOCUSIGN_DECLINE) {
      userAction = messages['app.docusign.digisign.userdeclined'];
    } else if (action === DOCSIGN_CONSTANTS.DOCUSIGN_ACCESS_CODE_FAILED) {
      userAction = messages['app.docusign.digisign.accesscodefailed'];
    } else if (action === DOCSIGN_CONSTANTS.DOCUSIGN_CANCEL) {
      userAction = messages['app.docusign.digisign.cancel'];
    } else if (action === DOCSIGN_CONSTANTS.DOCUSIGN_TTL_EXPIRED) {
      userAction = messages['app.docusign.digisign.ttlexpired'];
    }
  }

    componentWillUnmount() {
        this.props.setDocuSignURLResponse('');
        this.props.setcompleteDocumentSignResponseError('');
    }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.docusignaccept.completeDocumentSignResponse !== this.props.docusignaccept.completeDocumentSignResponse) {
      this.setState({
        docusignResponseReceived: true
      })
    }
  }

  onOKButton() {
    this.props.resetCompleteDocusignResponseSuccess();
    this.props.changePage('/portfolios', true);
    this.props.changePage('/docsign/document-list');
  }

  modalContent() {
    const {
      i18n: { messages },
      docusignaccept: {
        completeDocumentSignResponseError,
        documentName,
      }
    } = this.props;

    if (!this.state.docusignResponseReceived) {
      return (
        <div className="padding-top-50 padding-bottom-50">
          <Loading />
          <Text className="center-content" secondary> {messages['app.docusign.digisign.processinfo']}</Text>
        </div>
      );
    }

    if (completeDocumentSignResponseError) {
      return (
        <div className="acceptsign-modal">
          <div className="modal-content center-content">
            <Text secondary style={StyleSheet.flatten(styles.errorText)}>
              {completeDocumentSignResponseError}
            </Text>
          </div>
          <div className="modal-footer">
            <div style={StyleSheet.flatten(styles.successButton)}>
              <div className="acceptsign-btn">
                <Button
                  fullWidth
                  onPress={this.onOKButton}
                >
                  {messages['app.rmcallback.okMsg']}
                </Button>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="acceptsign-modal">
        <div className="modal-content">
          <Text secondary>
            {userAction + documentName}
          </Text>
        </div>
        <div className="modal-footer">
          <div style={StyleSheet.flatten(styles.successButton)}>
            <div className="acceptsign-btn">
              <Button
                fullWidth
                onPress={this.onOKButton}
              >
                {messages['app.rmcallback.okMsg']}
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { i18n: { messages } } = this.props;
    return (
      <Modal
        isActive
        hideCloseButton
        disableOutsideClick
        doneLabel={false}
        backVisible={false}
        onClose={() => { }}
        header={messages['app.docsign.pageTitle.subscriptionConfirmation']}
        content={this.modalContent()}
      />
    );
  }
}

export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
    changePage: { $call: 'ui.history.push' },
    resetCompleteDocusignResponseSuccess: { $call: 'docusignaccept.resetCompleteDocusignResponseSuccess' },
    docusignaccept: {
      documentName: true,
      signAction: true,
      completeDocumentSignResponse: true,
      docuSignURLResponse: true,
      completeDocumentSignResponseError: true
    },
    completeDocumentSign: { $call: 'docusignaccept.completeDocumentSign' },
    setDocuSignURLResponse: { $set: 'docusignaccept.docuSignURLResponse' },
    setcompleteDocumentSignResponseError: { $set: 'docusignaccept.completeDocumentSignResponseError' }
  },
})(DocusignResponseModal);
